export default function lozadAdv() {
  return {
    controller: 'LozadAdvCtrl',
    bindToController: true,
    controllerAs: 'lozadAdv',
    scope: true
  };
}